define('views/modules/member/member-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/layout',
    // collections
    'collections/member/groups',
    // views
    'views/parts/panel/base-panel',
    'views/modules/member/member/member-content',
    'views/modules/member/group/group-content'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    LayoutState,
    // collections
    CGroups,
    // views
    VBasePanel,
    VMemberContent,
    VGroupContent
) {

    var VMemberPanel = VBasePanel.extend({
        header: {
            title: "Clients",
            subtitle: "Manage the clients and groups",
        },
        tabs: [
            { id: "member", title: 'Clients', icon: 'sl-icon-people', active: true, callback: 'showMember' },
            //{ id: "group", title: 'Groups', icon: 'sl-icon-layers', callback: 'showGroup' },
        ],

        content: {
            member: VMemberContent,
            //group: VGroupContent
        },
        defaultView: 'member',

        initialize: function(opt) {
            opt = opt || {};
            this.url = opt.url;

            this.collection = new CGroups(null, { tree: true, tree_only: true, removeExpired: true });

            var memberView = this.getView('member');

            this.listenTo(memberView, { 'member:select': this.onMemberSelect });
        },

        render: function() {
            VMemberPanel.__super__.render.apply(this, arguments);
            this.collection.fetch();
            return this;
        },

        getContentViewOptions: function(options) {
            return _.extend({
                model: this.model, // currently selected user
                collection: this.collection, // group list
                url: this.url,
            }, this.options);
        },

        showMember: function() { this.showContent('member'); },
        //showGroup: function() { this.showContent('group'); },

        onMemberSelect: function() {
            if (Viewport.isMobile()) this.close();
        },

    });

    return VMemberPanel;
});

